module.exports = __webpack_public_path__ + "static/fapeg-aa614b6778d3399ecf8ae4142bfbec39.png";